import { CopyToClipboardButton } from '@library/components/buttons';
import type { SearchFilters } from '@library/types/members';
import { generateUrlWithSearchParams } from '@bo-utils/members/members';
import { useMemo } from 'react';

export interface MemberListHeaderProps {
  memberSearchFilters: SearchFilters;
}

export const MemberListHeader = ({
  memberSearchFilters
}: MemberListHeaderProps) => {
  const urlWithSearchParams = useMemo(
    () => generateUrlWithSearchParams(memberSearchFilters),
    [memberSearchFilters]
  );

  return (
    <div className="border-soFresh-140 flex h-16 w-full items-center justify-between border-b px-6 pb-3">
      <div className="flex flex-col pl-1">
        <h2 className="text-soClean-180">Members</h2>
        <p className="text-soClean-100">All Members</p>
      </div>
      <div className="ml-auto flex items-center justify-center">
        <CopyToClipboardButton
          bannerMessage="Copied Search Results to Clipboard"
          btnClassName="size-10 hover:bg-soFresh-130 rounded-md text-soClean-180 hover:text-soClean-100"
          iconSize={6}
          textCopied={urlWithSearchParams}
        />
      </div>
    </div>
  );
};
